import { accountModule } from '@app/store'
import { computed, getCurrentInstance } from '@nuxtjs/composition-api'
import AccountType from '@app/constants/AccountType'

export default function useAccount() {
  const account = computed(() => {
    console.log(`[Log] computed account `, accountModule.account)
    return accountModule.account
  })
  const isSalon = computed(() => {
    return accountModule.accountType == AccountType.salon
  })
  const isIndivisual = computed(() => {
    return accountModule.accountType == AccountType.indivisual
  })
  const name = computed(() => {
    console.log(
      `[Log] computed name `,
      `${accountModule.name1} ${accountModule.name2}`
    )
    return `${accountModule.name1} ${accountModule.name2}`
  })
  const nameFrigana = computed(() => {
    return `${accountModule.name1Furigana} ${accountModule.name2Furigana}`
  })

  const lineId = computed(() => {
    return `${accountModule.lineId}`
  })

  const email = computed(() => {
    return `${accountModule.email}`
  })
  const tel = computed(() => {
    return `${accountModule.tel}`
  })
  const zipcode = computed(() => {
    if (isIndivisual.value) {
      return accountModule.zipcode
    } else {
      return accountModule.salonZipcode
    }
  })

  const address = computed(() => {
    if (isIndivisual.value) {
      return `${accountModule.address1}${accountModule.address2}${accountModule.address3}${accountModule.address4}`
    } else {
      return `${accountModule.salonAddress1}${accountModule.salonAddress2}${accountModule.salonAddress3}${accountModule.salonAddress4}`
    }
  })
  const address1 = computed(() => {
    if (isIndivisual.value) {
      return accountModule.address1
    } else {
      return accountModule.salonAddress1
    }
  })
  const address2 = computed(() => {
    if (isIndivisual.value) {
      return accountModule.address2
    } else {
      return accountModule.salonAddress2
    }
  })
  const address3 = computed(() => {
    if (isIndivisual.value) {
      return accountModule.address3
    } else {
      return accountModule.salonAddress3
    }
  })
  const address4 = computed(() => {
    if (isIndivisual.value) {
      return accountModule.address4
    } else {
      return accountModule.salonAddress4
    }
  })
  const corporateName = computed({
    get() {
      return `${accountModule.corporateName}`
    },
    set(value: string) {
      accountModule.setCorporateName(value)
    },
  })
  const representative = computed({
    get() {
      return `${accountModule.representative}`
    },
    set(value: string) {
      accountModule.setRepresentative(value)
    },
  })
  const salonName = computed(() => {
    return `${accountModule.salonName}`
  })
  const salonNameFurigana = computed(() => {
    return `${accountModule.salonNameFurigana}`
  })
  const salonTel = computed(() => {
    return `${accountModule.salonTel}`
  })
  const salonUrl = computed(() => {
    return `${accountModule.salonUrl}`
  })

  const root = getCurrentInstance()
  const i18n = root?.proxy.$i18n!
  const contractType = computed(() => {
    switch (accountModule.contract.toString()) {
      case '0':
        return i18n.t('あり')

      case '1':
        return i18n.t('なし')

      case '2':
        return i18n.t('不明')

      default:
        break
    }
  })
  return {
    account,
    isSalon,
    isIndivisual,
    name,
    nameFrigana,
    lineId,
    email,
    tel,
    zipcode,
    address,
    address1,
    address2,
    address3,
    address4,
    salonName,
    salonTel,
    salonUrl,
    corporateName,
    representative,
    salonNameFurigana,
    contractType,
  }
}
